import React from "react";
import { Paper, Box, Typography, IconButton } from "@mui/material";
import { BookOpen as BookOpenIcon, Pencil as PencilIcon, Trash as TrashIcon, ChevronRight as ChevronRightIcon } from "lucide-react";

const CourseItem = ({ course, onSelectCourse }) => {
  return (
    <Paper
      elevation={1}
      sx={{
        p: 2,
        mb: 1,
        borderRadius: 2,
        cursor: 'pointer',
        transition: 'all 0.2s',
        borderLeft: 'none',
        background: 'white',
        '&:hover': {
          bgcolor: '#f5f5f5'
        }
      }}
      onClick={() => onSelectCourse(course._id)}
    >
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <BookOpenIcon size={18} color="#1976d2" style={{ marginRight: 8 }} />
          <Typography variant="subtitle1" fontWeight="medium">
            {course.title}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex' }}>
          <IconButton size="small" color="primary">
            <PencilIcon size={16} />
          </IconButton>
          <IconButton size="small" color="error">
            <TrashIcon size={16} />
          </IconButton>
          <IconButton size="small" color="primary">
            <ChevronRightIcon size={16} />
          </IconButton>
        </Box>
      </Box>
    </Paper>
  );
};

export default CourseItem;
